import type { FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../repositories/offers-comparison/entities/schemas/ErrorResponseSchema';
import type { TAddOfferToComparisonResponse } from '../../../../repositories/offers-comparison/v2/add-offer-to-comparison';

export const mapAddOfferToComparisonResponseError = (
  response: IErrorResponseSchema,
): FetchResponse<TAddOfferToComparisonResponse> => {
  return {
    statusCode: 400,
    headers: [] as unknown as Headers,
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
